// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditApplicant-module_modal_1DFDl"};